import React from "react";

const DownloadArea = () => {
  return (
    <div className="bg-info p-2">
      <h2 className="text-uppercase">download area</h2>
      <p>
        All the course content and <br />
        syllabus will be here soon.
      </p>
      <button type="button" className="btn btn-outline-light mt-4 mb-4">
        Show More
      </button>
    </div>
  );
};

export default DownloadArea;
